module.exports = __webpack_public_path__ + "img/icon-gongan.d0289dc0.png";